import { PermissionControl } from "../../../components/Permission";
import { permissions } from "../../../utils/permissions";
import { getRole } from "../../../services/api/utils.api";
import { useAppSelector, useAppThunkDispatch } from "../../../store/hooks";
import { selectUsers } from "../../../store/selectors/userSelector";
import { getActiveUser } from "../../../store/actions/userActions";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Form from "../../../components/Forms/UserForm";
import { Admin, Operator, Role, ROLES } from "../../../types/user";
import { fetchUser } from "../../../services/api/users.api";
import { handleApiError } from "../../../utils/handleApiError";
import AlertDialog from "../../../components/Alert";
import Loading from "../../../components/Loading";

const UserFormPage = () => {
  const { role, id } = useParams();
  const dispatch = useAppThunkDispatch();
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  console.log(id);

  const fetchData = (role: Role, username: string) => {
    setIsLoading(true);
    fetchUser(role, username)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((e) => {
        handleApiError(e, setError);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    id &&
      (role === ROLES.ADMIN || role === ROLES.OPERATOR) &&
      fetchData(role, id);
  }, [id, role]);

  useEffect(() => {
    if (data) {
      const enrichedUser: Admin | Operator = {
        ...data,
        role: role,
        schools: data.schools || [""],
      };
      data && dispatch(getActiveUser(enrichedUser));
    }
  }, [data]);

  if (isLoading) return <Loading />;

  return (
    <PermissionControl
      permissionPath={permissions.pages.users.update}
      role={getRole()}
    >
      {data && (role === ROLES.ADMIN || role === ROLES.OPERATOR) && (
        <Form role={role} />
      )}
      {error && (
        <AlertDialog
          title={"System Error"}
          message={error || ""}
          buttons={[
            {
              label: "Ok",
              onClick: () => {
                setError(undefined);
              },
            },
          ]}
        />
      )}
    </PermissionControl>
  );
};
export default UserFormPage;
